import {Component, inject, OnInit, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {CompaniesApiService} from '@core/services/api/companies-api.service';
import {AlertService} from '@core/services/alert.service';
import {CurrencyPipe} from '@angular/common';

@Component({
    selector: 'app-negotiation-strategy-modal',
    standalone: true,
    imports: [CommonModule, CurrencyPipe],
    templateUrl: './negotiation-strategy-modal.component.html',
    styleUrl: './negotiation-strategy-modal.component.scss'
})
export class NegotiationStrategyModalComponent implements OnInit {
    protected activeModal = inject(NgbActiveModal);
    private companiesApiService = inject(CompaniesApiService);
    private alertService = inject(AlertService);

    // Input
    companyId!: number;

    // State
    protected isLoading = signal(true);
    protected strategy = signal<any>(null);

    ngOnInit(): void {
        this.loadNegotiationStrategy();
    }

    private loadNegotiationStrategy(): void {
        this.isLoading.set(true);

        this.companiesApiService.getNegotiationStrategy(this.companyId).subscribe({
            next: (response: any) => {
                if (response.success && response.data) {
                    this.strategy.set(response.data);
                }
                this.isLoading.set(false);
            },
            error: () => {
                this.alertService.error('Erro', 'Falha ao carregar estratégia de negociação');
                this.isLoading.set(false);
            }
        });
    }

    protected getPriorityLabel(priority: number): string {
        const labels: Record<number, string> = {
            1: 'Muito Baixa',
            2: 'Baixa',
            3: 'Média',
            4: 'Alta',
            5: 'Muito Alta'
        };
        return labels[priority] || 'N/A';
    }

    protected getPriorityColor(priority: number): string {
        const colors: Record<number, string> = {
            1: 'secondary',
            2: 'info',
            3: 'warning',
            4: 'warning',
            5: 'danger'
        };
        return colors[priority] || 'secondary';
    }

    protected getRiskColor(riskScore: number): string {
        if (riskScore <= 0.3) return 'success';
        if (riskScore <= 0.6) return 'warning';
        return 'danger';
    }

    protected getRiskLabel(riskScore: number): string {
        if (riskScore <= 0.3) return 'Baixo';
        if (riskScore <= 0.6) return 'Médio';
        return 'Alto';
    }

    close(): void {
        this.activeModal.close();
    }
}

